import { StyleSheet } from 'aphrodite'

import table from './table'
import tickets from './tickets'

export default {
  table: StyleSheet.create(table),
  tickets: StyleSheet.create(tickets)
}



// WEBPACK FOOTER //
// ./src/components/Support/style/ColorBlind/index.js